"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Newsletter = exports.fadeIn = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const newsletter_hooks_1 = require("../../shared/newsletter.hooks");
const NewsletterButton_atom_1 = require("./NewsletterButton.atom");
const NewsletterCloseBtn_atom_1 = require("./NewsletterCloseBtn.atom");
const NewsletterForm_molecule_1 = require("./NewsletterForm.molecule");
exports.fadeIn = (0, styled_components_1.keyframes) `
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
const Styled = styled_components_1.default.div `
    img {
        width: 130px;
        height: 130px;
        background-size: 100%;
        position: absolute;
        top: -60px;
        left: calc(50% - 65px);
        max-width: 130px;
    }

    button {
        appearance: none;
        background: none;
        border-style: none;
    }
`;
const Modal = styled_components_1.default.div `
    position: fixed;
    z-index: 9001;
    top: 50%;
    left: 50%;
    height: 370px;
    width: calc(100% - 32px);
    background-color: white;
    transform: translateX(-50%) translateY(-50%);
    box-shadow: rgb(50 50 50 / 60%) 0px 0px 20px 0px;
    max-width: 460px;
    min-height: 370px;

    .relative {
        position: relative;
        height: 100%;
    }

    animation: ${exports.fadeIn} 0.8s;
`;
const Overlay = styled_components_1.default.div `
    position: fixed;
    z-index: 9000;
    background: #000;
    opacity: 0.2;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
`;
const Newsletter = ({ locale, isLoggedIn = false, email, enableNewsLetter, newsLetterConfigs = {}, newsLetterReactConfig = {} }) => {
    const { logo, titleMsg } = newsLetterConfigs;
    const [open, setOpen] = (0, react_1.useState)(false);
    const { getStatus, loaded, loading, error, subscribed } = (0, newsletter_hooks_1.useNewsletterStatus)();
    const toggleOpen = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const newOpen = !open;
        setOpen(newOpen);
        if (isLoggedIn && newOpen && !loading && !loaded && !subscribed && !error) {
            getStatus();
        }
    }, [open, setOpen, getStatus, isLoggedIn]);
    let showNewsLetter = false;
    if (enableNewsLetter) {
        if (newsLetterConfigs.loginRequired) {
            showNewsLetter = isLoggedIn;
        }
        else {
            showNewsLetter = true;
        }
    }
    if (!showNewsLetter)
        return null;
    return (react_1.default.createElement(Styled, { className: "newsletter" },
        react_1.default.createElement(NewsletterButton_atom_1.NewsletterButton, { className: "newsletter-signup", onClick: toggleOpen, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick }, titleMsg),
        open && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Modal, { className: "newsletter-modal" },
                react_1.default.createElement("div", { className: "relative" },
                    logo && react_1.default.createElement("img", { className: "newsletter-logo", src: logo, alt: "logo" }),
                    react_1.default.createElement(NewsletterCloseBtn_atom_1.NewsletterCloseButton, { onClick: toggleOpen, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick }),
                    react_1.default.createElement(NewsletterForm_molecule_1.NewsletterForm, { newsLetterReactConfig: newsLetterReactConfig, newsLetterConfigs: newsLetterConfigs, locale: locale, email: email, statusSubscribed: subscribed }))),
            react_1.default.createElement(Overlay, { onClick: toggleOpen })))));
};
exports.Newsletter = Newsletter;
//# sourceMappingURL=Newsletter.organism.js.map